import {Raven} from 'vue-raven'
import * as moment from 'moment'
import chrono from 'chrono-node'

// https://stackoverflow.com/a/25842472/7732655
moment.locale(window.navigator.userLanguage || window.navigator.language)

// So far we just need the difference between US and UK/Australia time
const isUSA = moment.localeData().longDateFormat('L') === 'MM.DD.YYYY'

export const getLocaleDateDefaultFormat = () => {
    return isUSA ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
}

/**
 * Flatpikr has own date formatting tokens (https://flatpickr.js.org/formatting/)
 * that differs with moment js or other formats.
 */
const flatPickrDefaultDateFormats = Object.freeze({
    'en-US': 'm/d/Y',
    'en-GB': 'd/m/Y'
    // since flatpikr day of the month it is 2 digits with leading zeros (01 to 31)
    // we cant achieve 'd/MM/yyyy' format for AU,
    // so we use 'dd/MM/yyyy' format for GB and AU.
})

export const getFlatpickrAltFormat = () => {
    return isUSA ? flatPickrDefaultDateFormats['en-US'] : flatPickrDefaultDateFormats['en-GB']
}

export const getFlatpikrConvertedDate = dateString => {
    try {
        if (typeof dateString === 'string') {
            const locale = getFlatpickrAltFormat() === flatPickrDefaultDateFormats['en-US'] ? 'en' : 'en_GB'
            return chrono[locale].parseDate(dateString)
        }
        return null
    } catch (e) {
        Raven.captureException(e)
        return null
    }
}
